module.exports = __webpack_public_path__ + "img/locIcon.b06598dc.png";